import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from 'react-query'
import { Toaster } from 'react-hot-toast'
import App from './App.tsx'
import './index.css'
import './i18n'

// MSW setup disabled for production
// const shouldUseMocks = import.meta.env.DEV || import.meta.env.VITE_USE_MOCKS === 'true'
// async function startMocks() {
//   if (shouldUseMocks) {
//     try {
//       const { worker } = await import('./mocks/browser')
//       await worker.start({ 
//         onUnhandledRequest: 'bypass',
//         quiet: false
//       })
//     } catch (error) {
//       console.error('❌ MSW failed to start:', error)
//     }
//   }
// }
// startMocks()

// Setup React app
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
        <Toaster 
          position="top-center"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
            },
            success: {
              duration: 3000,
              iconTheme: {
                primary: '#28A745',
                secondary: '#fff',
              },
            },
            error: {
              duration: 5000,
              iconTheme: {
                primary: '#DC3545',
                secondary: '#fff',
              },
            },
          }}
        />
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
)
